import moment from 'moment';

export function Registration(data) {
  //ejohn.org/blog/javascript-getters-and-setters
  // ReSharper disable MisuseOfOwnerFunctionThis
  this.date = new Date();
  this.relation = null;
  this.invoiceStreamId = null;
  this.invoiceStream = null;
  this.resource = null;
  this.type = null;
  this.resourceDescription = '';
  this.isBillable = true;
  this.inForfait = null;
  this.vatPercentage = 0.0;
  this.vatType = 0;
  this.remark = '';
  this.internalRemark = '';
  this.isBilled = false;
  this.interactionId = null;
  this.interactionType = null;
  this.interactionDescription = null;
  this.interactionTitle = null;
  this.neverInvoice = false;
  this.taskName = null;
  this.plannedTaskId = null;
  this.plannedTaskName = null;
  this.plannedTaskTemplateId = null;
  this.plannedTaskTemplateType = null;
  this.mainPlannedTaskId = null;
  this.mainPlannedTaskName = null;
  this.mainTaskTemplateId = null;
  this.referenceYear = null;
  this.isFixedPrice = false;
  this.trainingId = null;
  this.trainingName = null;
  this.invoiceInForfait = null;

  this.validate = function() {
    return (
      this.validateTo() &&
      this.validateDuration() &&
      this.validateAmount &&
      this.validateQuantity() &&
      this.validateDescription()
    );
  };
  this.invalidDescription = false;

  this.__defineGetter__('hasResource', function() {
    return this.resource && this.resource.id;
  });

  this.__defineGetter__('resourceName', function() {
    if (!this.resource) return null;
    return (this.resource.isOther ? this.resourceDescription : null) || this.resource.name;
  });
  this.__defineGetter__('fullRemark', function() {
    return (this.remark || '') + ' ' + (this.internalRemark || '');
  });

  this.__defineGetter__('hasNoPrice', function() {
    return (this.resource || this.resourceDescription) && !this.price && !this.amount;
  });
  //From
  var fromHour = 0;
  var fromMinute = 0;
  this.__defineGetter__('fromHour', function() {
    return fromHour;
  });
  this.__defineSetter__('fromHour', function(value) {
    fromHour = value;
    if (value * 60 + fromMinute <= this.toMinutes) {
      this.durationMinutes = this.toMinutes - this.fromMinutes;
    }
  });
  this.__defineGetter__('fromMinute', function() {
    return fromMinute;
  });
  this.__defineSetter__('fromMinute', function(value) {
    fromMinute = value;
    if (fromHour * 60 + value <= this.toMinutes) {
      this.durationMinutes = this.toMinutes - this.fromMinutes;
    }
  });

  this.__defineGetter__('fromMinutes', function() {
    return fromHour * 60 + fromMinute;
  });
  this.setFromMinutes = function(value) {
    fromHour = parseInt(value / 60);
    fromMinute = parseInt(value - fromHour * 60);
  };
  this.__defineSetter__('fromMinutes', function(value) {
    if (this.fromMinutes !== value) this.setToMinutes(value + this.durationMinutes);
    this.setFromMinutes(value);
  });

  this.__defineGetter__('fromFormatted', function() {
    return fromHour + ':' + (fromMinute < 10 ? '0' : '') + fromMinute;
  });

  //To
  var toHour = 0;
  var toMinute = 0;
  this.invalidTo = false;

  this.__defineGetter__('toHour', function() {
    return toHour;
  });
  this.__defineSetter__('toHour', function(value) {
    toHour = value;
    //if (value * 60 + toMinute >= this.fromMinutes) {
    this.durationMinutes = this.toMinutes - this.fromMinutes;
    //}
    this.validateTo();
  });
  this.__defineGetter__('toMinute', function() {
    return toMinute;
  });
  this.__defineSetter__('toMinute', function(value) {
    toMinute = value;
    //if (toHour * 60 + value >= this.fromMinutes) {
    this.durationMinutes = this.toMinutes - this.fromMinutes;
    //}
    this.validateTo();
  });

  this.__defineGetter__('toMinutes', function() {
    return toHour * 60 + toMinute;
  });
  this.setToMinutes = function(value) {
    toHour = parseInt(value / 60);
    toMinute = parseInt(value - toHour * 60);
    this.validateTo();
  };
  this.__defineSetter__('toMinutes', function(value) {
    if (this.toMinutes !== value) this.setDurationMinutes(value - this.fromMinutes);
    this.setToMinutes(value);
  });

  this.__defineGetter__('toFormatted', function() {
    return toHour + ':' + (toMinute < 10 ? '0' : '') + toMinute;
  });

  this.validateTo = function() {
    this.invalidTo =
      this.type === 0 &&
      this.resource &&
      (!this.resource.isOther || !!this.resourceDescription) &&
      this.toMinutes <= this.fromMinutes; //To must exceed from.
    return !this.invalidTo;
  };

  //Duration
  var durationHour = 0;
  var durationMinute = 0;
  this.invalidDuration = false;

  this.__defineGetter__('durationHour', function() {
    return durationHour;
  });
  this.__defineSetter__('durationHour', function(value) {
    durationHour = value;
    this.toMinutes = this.fromMinutes + this.durationMinutes;
    if (this.validateDuration()) this.tempTotal = null;
  });

  this.__defineGetter__('durationMinute', function() {
    return durationMinute;
  });
  this.__defineSetter__('durationMinute', function(value) {
    durationMinute = value;
    this.toMinutes = this.fromMinutes + this.durationMinutes;
    if (this.validateDuration()) this.tempTotal = null;
  });

  this.__defineGetter__('durationMinutes', function() {
    return durationHour * 60 + durationMinute;
  });
  this.setDurationMinutes = function(value) {
    durationHour = parseInt(value / 60);
    durationMinute = parseInt(value - durationHour * 60);
    if (this.validateDuration()) this.tempTotal = null;
  };
  this.__defineSetter__('durationMinutes', function(value) {
    if (this.durationMinutes !== value) this.setToMinutes(this.fromMinutes + value);
    this.setDurationMinutes(value);
  });

  this.__defineGetter__('durationFormatted', function() {
    return durationHour + ':' + (durationMinute < 10 ? '0' : '') + durationMinute;
  });

  this.validateDuration = function() {
    this.invalidDuration =
      this.type === 0 && this.resource && this.toMinutes <= 0 && this.durationMinutes <= 0; //To nor duration.
    return !this.invalidDuration;
  };
  this.validateDescription = function() {
    let validateDescription = false;

    if (this.type === 0 && this.toMinutes > 0 && this.durationMinutes > 0) {
      validateDescription = true;
    }
    if ((this.type === 1 || this.type === 2) && this.amount > 0) {
      validateDescription = true;
    }

    if (!validateDescription) return true;

    this.invalidDescription = !this.resource || !this.resource.name;

    return !this.invalidDescription;
  };
  //Quantity
  var quantity = 0.0;
  this.invalidQuantity = false;

  this.__defineGetter__('quantity', function() {
    return quantity;
  });
  this.__defineSetter__('quantity', function(value) {
    quantity = value;
    if (this.validateQuantity()) this.tempTotal = null;
  });

  this.validateQuantity = function() {
    this.invalidQuantity = this.resource && this.quantity <= 0 && this.type === 1; //Required quantity.
    return !this.invalidQuantity;
  };

  //Amount
  var amount = 0.0;
  this.invalidAmount = false;

  this.__defineGetter__('amount', function() {
    return amount;
  });
  this.__defineSetter__('amount', function(value) {
    amount = value;
    if (this.price && this.price.amount !== amount) this.price = null;
    if (this.validateAmount()) this.tempTotal = null;
  });

  this.__defineGetter__('displayAmount', function() {
    return this.quantity > 0 ? this.amount : 0;
  });
  this.__defineSetter__('displayAmount', function(value) {
    this.amount = value;
  });

  this.__defineGetter__('fractionSize', function() {
    var n = amount ? amount.getFractionSize() : 0;
    return n > 2 ? n : 2;
  });

  this.validateAmount = function() {
    this.invalidAmount = this.resource && this.amount <= 0; //Required amount.
    return !this.invalidAmount;
  };

  //Price
  var price = null;
  var priceOptions = null;

  this.__defineGetter__('price', function() {
    return price;
  });
  this.__defineSetter__('price', function(value) {
    price = value;
    if (price) {
      this.amount = price.amount;
    }
  });

  //Amount
  var discountPercentage = 0.0;

  this.__defineGetter__('discountPercentage', function() {
    return discountPercentage;
  });
  this.__defineSetter__('discountPercentage', function(value) {
    discountPercentage = value;
  });

  //VAT percentage
  this.setVatRate = function(vatRate, vatType) {
    this.vatPercentage = vatRate;
    this.vatType = vatType;
  };

  //Total
  this.tempTotal = null;
  this.__defineGetter__('total', function() {
    if (this.tempTotal !== null) return this.tempTotal;
    var sum;
    if (this.type === 0 && this.isFixedPrice) {
      sum = this.amount;
    } else if (this.durationMinutes > 0) {
      sum = (parseFloat(this.durationMinutes) / 60) * this.amount;
    } else if (this.type == 1 && this.quantity < 0) {
      sum = this.amount;
    } else {
      sum = this.quantity * this.amount;
    }
    sum = sum * (1 - this.discountPercentage);

    return Math.round(sum * 100) / 100;
  });
  this.__defineSetter__('total', function(value) {
    var sum = Math.abs(parseFloat(value));
    if (isNaN(sum)) {
      this.tempTotal = '';
      return 0;
    }
    this.tempTotal = null;
    var quantity = 1;
    if (this.type === 0 && this.isFixedPrice) {
      quantity = 1;
    } else if (this.durationMinutes > 0) {
      quantity = this.durationMinutes / 60;
    } else if (this.quantity > 0) {
      quantity = this.quantity;
    }
    var prevTotal = quantity * this.amount;
    this.discountPercentage = prevTotal === 0 ? 0 : (prevTotal - sum) / (prevTotal * 1.0);
    //if (prevTotal >= sum) {

    //} else {
    //    this.discountPercentage = 0;
    //    this.amount = sum / quantity;
    //}
  });

  //Methods
  this.add = function(minutes) {
    if (this.toMinutes + minutes < 1440) {
      //1440 = 24h
      this.durationMinutes += minutes;
    }
  };

  this.round = function(minutes) {
    //stackoverflow.com/questions/4968250/how-to-round-time-to-the-nearest-quarter-hour-in-javascript
    this.durationMinutes = Math.round(this.durationMinutes / minutes, 10) * minutes;

    if (this.toHour > 23) {
      this.toHour = 23;
      this.toMinute = 59;
    }
  };

  this.initTime = function(fromHour, fromMinute, durationMinutes) {
    this.toMinutes = fromHour * 60 + fromMinute + durationMinutes;
    this.fromHour = fromHour; //Must be set after the to-time due to the validation.
    this.fromMinute = fromMinute;
  };

  this.setTaskFields = function({
    plannedTaskId = null,
    plannedTaskName = null,
    plannedTaskTemplateId = null,
    plannedTaskTemplateType = null,
    mainPlannedTaskId = null,
    mainPlannedTaskName = null,
    mainTaskTemplateId = null,
  } = {}) {
    this.plannedTaskId = plannedTaskId;
    this.plannedTaskName = plannedTaskName;
    this.plannedTaskTemplateId = plannedTaskTemplateId;
    this.plannedTaskTemplateType = plannedTaskTemplateType;
    this.mainPlannedTaskId = mainPlannedTaskId;
    this.mainPlannedTaskName = mainPlannedTaskName;
    this.mainTaskTemplateId = mainTaskTemplateId;
  };
  this.clearTaskFields = function() {
    this.setTaskFields();
  };

  this.setTaskName = function(regTaskNameFilter) {
    if (!this.plannedTaskId) return;
    this.taskName = regTaskNameFilter(this);
  };

  this.setResourceName = function(resourceNameFilter) {
    if (!this.resource || !resourceNameFilter) return;
    this.resource.name = resourceNameFilter(this.resource);
  };

  this.translate = function($filter) {
    this.setResourceName($filter('resourceName'));
    this.setTaskName($filter('regTaskName'));
  };

  this.set = function(data) {
    if (data) {
      if (data.id) this.id = data.id;
      if (data.group) this.group = data.group;
      if (data.userId) this.userId = data.userId;
      if (data.user) this.user = data.user;
      if (data.date) this.date = moment.utc(data.date).toDate();
      if (data.relation) this.relation = data.relation;

      if (data.plannedTaskId) this.plannedTaskId = data.plannedTaskId;
      if (data.plannedTaskTemplateId) this.plannedTaskTemplateId = data.plannedTaskTemplateId;
      if (data.plannedTaskName) this.plannedTaskName = data.plannedTaskName;
      if (data.plannedTaskTemplateType) this.plannedTaskTemplateType = data.plannedTaskTemplateType;

      if (data.mainPlannedTaskId) this.mainPlannedTaskId = data.mainPlannedTaskId;
      if (data.mainTaskTemplateId) this.mainTaskTemplateId = data.mainTaskTemplateId;
      if (data.mainPlannedTaskName) this.mainPlannedTaskName = data.mainPlannedTaskName;
      if (data.taskName) this.taskName = data.taskName;

      if (data.invoiceStreamId) this.invoiceStreamId = data.invoiceStreamId;
      if (data.invoiceStream) this.invoiceStream = data.invoiceStream;
      if (typeof data.type !== 'undefined') this.type = data.type;
      if (typeof data.isFixedPrice !== 'undefined') this.isFixedPrice = data.isFixedPrice;
      if (data.resource) this.resource = data.resource;
      if (data.resourceDescription) this.resourceDescription = data.resourceDescription;
      if (typeof data.fromMinutes !== 'undefined') this.fromMinutes = data.fromMinutes;
      if (typeof data.toMinutes !== 'undefined') this.toMinutes = data.toMinutes;
      if (typeof data.durationMinutes !== 'undefined') this.durationMinutes = data.durationMinutes;
      if (data.price) this.price = data.price; //Before the amount is set.
      if (typeof data.amount !== 'undefined') this.amount = data.amount;
      if (typeof data.discountPercentage !== 'undefined')
        this.discountPercentage = data.discountPercentage;
      if (typeof data.quantity !== 'undefined') this.quantity = data.quantity;
      if (typeof data.isBillable !== 'undefined') this.isBillable = data.isBillable;
      if (typeof data.inForfait !== 'undefined') this.inForfait = data.inForfait;
      if (typeof data.invoiceInForfait !== 'undefined')
        this.invoiceInForfait = data.invoiceInForfait;
      if (typeof data.vatPercentage !== 'undefined') this.vatPercentage = data.vatPercentage;
      if (typeof data.vatType !== 'undefined') this.vatType = data.vatType;
      if (typeof data.remark) this.remark = data.remark;
      if (typeof data.internalRemark) this.internalRemark = data.internalRemark;
      if (typeof data.isBilled !== 'undefined') this.isBilled = data.isBilled;
      if (typeof data.totalAmount !== 'undefined') this.totalAmount = data.totalAmount;
      if (typeof data.invoiceNumber !== 'undefined') this.invoiceNumber = data.invoiceNumber;
      if (typeof data.invoiceDate !== 'undefined' && data.invoiceDate)
        this.invoiceDate = moment.utc(data.invoiceDate);
      if (typeof data.invoiceId !== 'undefined') this.invoiceId = data.invoiceId;
      if (typeof data.invoiceStatus !== 'undefined') this.invoiceStatus = data.invoiceStatus;
      if (typeof data.neverInvoice !== 'undefined') this.neverInvoice = data.neverInvoice;
      if (typeof data.interactionId !== 'undefined') this.interactionId = data.interactionId;
      if (typeof data.interactionType !== 'undefined') this.interactionType = data.interactionType;
      if (typeof data.interactionDescription !== 'undefined')
        this.interactionDescription = data.interactionDescription;
      if (typeof data.interactionTitle !== 'undefined')
        this.interactionTitle = data.interactionTitle;
      if (typeof data.referenceYear !== 'undefined') this.referenceYear = data.referenceYear;
      if (typeof data.trainingId !== 'undefined') this.trainingId = data.trainingId;
      if (typeof data.trainingName !== 'undefined') this.trainingName = data.trainingName;
      if (typeof data.isLocked !== 'undefined') this.isLocked = data.isLocked;
    }
  };
  if (data) this.set(data);

  this.reset = function() {
    console.warn('Registration.Reset() should be used!');
    this.resource = null;
    this.resourceDescription = '';
    this.fromMinutes = 0;
    this.toMinutes = 0;
    this.durationMinutes = 0;
    this.amount = 0.0;
    this.quantity = 0.0;
    this.isBillable = false;
    this.inForfait = null;
    this.vatPercentage = 0.21;
    this.vatType = 0;
    this.price = null;
    this.priceOptions = null;
    this.totalAmount = 0.0;
    this.interactionType = null;
    this.interactionDescription = null;
    this.interactionTitle = null;
    this.isFixedPrice = false;
  };
}
